import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";

import "./Preloader.scss";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: "500px",
  },
  barColorPrimary: {
    backgroundColor: "#339933", // Your custom bar color
  },
  colorPrimary: {
    backgroundColor: "#e0e0e0", // The background (track) color
  },
}));

const Preloader = () => {
  const classes = useStyles();

  return (
    <div className="preloader-container">
      <div className={classes.root}>
        <LinearProgress
          classes={{
            barColorPrimary: classes.barColorPrimary,
            colorPrimary: classes.colorPrimary,
          }}
        />
      </div>
    </div>
  );
};

export default Preloader;
